var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDataAnalystBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 31,
    viewBox: "0 0 32 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8438 -8.9407e-08C7.09349 -8.9407e-08 0 6.72972 0 15.0312C0 23.3328 7.09349 30.0625 15.8438 30.0625C24.594 30.0625 31.6875 23.3328 31.6875 15.0312C31.6783 6.73335 24.5902 0.00876264 15.8438 -8.9407e-08V-8.9407e-08ZM26.7927 7.69918L17.0625 13.028V2.36598C20.9726 2.70608 24.529 4.65537 26.7927 7.69918V7.69918ZM14.625 2.36598V14.3621L3.67301 20.3601C1.84856 16.6085 2.05865 12.2498 4.23638 8.67182C6.41411 5.09381 10.2881 2.74232 14.625 2.36598V2.36598ZM15.8438 27.75C11.4885 27.7483 7.40551 25.7396 4.8948 22.3633L28.0145 9.70094C29.9305 13.6389 29.5991 18.2317 27.1354 21.8853C24.6718 25.5389 20.4155 27.7496 15.8438 27.75V27.75Z",
    fill: "#00067E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataAnalystBlue);
export default __webpack_public_path__ + "static/media/data-analyst-blue.cec342ef336efe9c0404d785fd0add9b.svg";
export { ForwardRef as ReactComponent };